module.exports = __webpack_public_path__ + "img/scheduling-w.d6115d3a.svg";